"use client";

import { c as _c } from "react/compiler-runtime";
import { AccountLockup } from "@opensea/app-kit";
import { readFragment } from "@opensea/graphql";
import { useAddress } from "@/hooks/wallet";
import { ProfilePreviewTooltip } from "../profile/ProfilePreviewTooltip/ProfilePreviewTooltip";
import { ActivityToFragment } from "./ActivityTo.fragment";
export function ActivityTo(t0) {
  const $ = _c(11);
  const {
    activity: activityKey,
    display: t1,
    className,
    showDisplayName: t2
  } = t0;
  const display = t1 === undefined ? "compact" : t1;
  const showDisplayName = t2 === undefined ? true : t2;
  let t3;
  if ($[0] !== activityKey) {
    t3 = readFragment(ActivityToFragment, activityKey);
    $[0] = activityKey;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const activity = t3;
  const connectedAddress = useAddress();
  if (!activity.to) {
    return null;
  }
  const t4 = connectedAddress ?? null;
  let t5;
  if ($[2] !== activity.to || $[3] !== className || $[4] !== display || $[5] !== showDisplayName || $[6] !== t4) {
    t5 = <AccountLockup account={activity.to} addressDisplay={display} className={className} connectedAddress={t4} disableTextOverflowTooltip={true} showDisplayName={showDisplayName} />;
    $[2] = activity.to;
    $[3] = className;
    $[4] = display;
    $[5] = showDisplayName;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== activity.to || $[9] !== t5) {
    t6 = <ProfilePreviewTooltip profile={activity.to}>{t5}</ProfilePreviewTooltip>;
    $[8] = activity.to;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}